import { __assign, __read } from "tslib";
import { transparentize } from 'polished';
import { getOffsetRangeColor } from '@keen.io/charts-utils';
export var getBarColor = function (_a) {
    var activeBar = _a.activeBar, barKey = _a.barKey, barSelector = _a.barSelector, groupMode = _a.groupMode, color = _a.color;
    if (groupMode === 'stacked') {
        var _b = __read(activeBar.selector, 2), activeProperty = _b[1];
        var _c = __read(barSelector, 2), barProperty = _c[1];
        if (activeProperty === barProperty) {
            return color;
        }
        if (activeProperty) {
            return transparentize(0.4, color);
        }
        return color;
    }
    return activeBar.key === barKey ? transparentize(0.05, color) : color;
};
export var calculateGroupedBars = function (data, groupScale, keys, labelSelector, disabledKeys, range, xScale, yScale, layout, colors, barsOrder, dataSeriesOffset) {
    var barSize = groupScale.bandwidth();
    var keysOrder = {};
    if (barsOrder) {
        data.forEach(function (_item, idx) {
            groupScale
                .domain()
                .sort(function (a, b) {
                var _a, _b, _c, _e;
                if (barsOrder === 'descending') {
                    return ((_a = data[idx]) === null || _a === void 0 ? void 0 : _a[b]) - ((_b = data[idx]) === null || _b === void 0 ? void 0 : _b[a]);
                }
                else {
                    return ((_c = data[idx]) === null || _c === void 0 ? void 0 : _c[a]) - ((_e = data[idx]) === null || _e === void 0 ? void 0 : _e[b]);
                }
            })
                .filter(function (keyName) { return data[idx][keyName]; })
                .forEach(function (keyName, index) {
                if (!keysOrder[idx])
                    keysOrder[idx] = {};
                keysOrder[idx][keyName] = index;
            });
        });
    }
    var bars = [];
    range.forEach(function (_d, index) {
        var counter = 0;
        var keysLength = keys.length;
        var barsToRenderInGroup = Object.entries(data[index]).filter(function (el) {
            if (el[1] === 0 &&
                el[0] !== labelSelector &&
                disabledKeys.includes(el[0]))
                keysLength--;
            return el[1] !== 0 && el[0] !== labelSelector;
        }).length;
        var newOrder = (keysLength - barsToRenderInGroup) / 2;
        var idx = 0;
        keys.forEach(function (keyName) {
            var _a;
            var isDisabled = keyName === labelSelector || disabledKeys.includes(keyName);
            var value = (_a = data[index]) === null || _a === void 0 ? void 0 : _a[keyName];
            if (value && !isDisabled) {
                var orderPosition = barsOrder
                    ? keysOrder[index][keyName] + newOrder
                    : counter + newOrder;
                var bar = layout === 'vertical'
                    ? {
                        x: xScale(data[index][labelSelector]) + barSize * orderPosition,
                        y: value > 0 ? yScale(value) : yScale(0),
                        width: barSize,
                        height: Math.abs(yScale(value) - yScale(0)),
                    }
                    : {
                        x: value > 0 ? Math.abs(xScale(0)) : xScale(value),
                        y: yScale(data[index][labelSelector]) + barSize * orderPosition,
                        width: Math.abs(xScale(value) - xScale(0)),
                        height: barSize,
                    };
                bars.push(__assign({ key: index + "." + keyName, selector: [index, keyName], color: getOffsetRangeColor(idx, colors, dataSeriesOffset), value: value, colorOutOfRange: dataSeriesOffset
                        ? idx < dataSeriesOffset[0] || idx >= dataSeriesOffset[1]
                        : !colors[idx] }, bar));
            }
            if (!barsOrder && !disabledKeys.includes(keyName) && value)
                counter++;
            idx++;
        });
    });
    return bars;
};
